import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './settings.constants';
import * as types from './settings.types';
import * as services from './settings.saga-services';

function* invokeInitialSettingsPage(action: types.IInitialSettingsPage) {
  yield call(services.initialSettingsPage);
}

function* invokeUpdateSettings(action: types.IUpdateSettings) {
  yield call(services.updateSettings, action.payload);
}

function* invokeResetPrimaryColors(action: types.IResetPrimaryColors) {
  yield call(services.resetPrimaryColors);
}

function* invokeResetSecondaryColors(action: types.IResetPrimaryColors) {
  yield call(services.resetSecondaryColors);
}

function* invokeFetchWrikeFolderMeetings(action: types.IFetchWrikeFolderMeetings) {
  yield call(services.fetchWrikeFolderMeetings);
}

export function* watchSettingsPageSaga() {
  yield takeLatest(constants.INITIAL_SETTINGS_PAGE, invokeInitialSettingsPage);
  yield takeLatest(constants.UPDATE_SETTINGS, invokeUpdateSettings);
  yield takeLatest(constants.RESET_PRIMARY_COLORS, invokeResetPrimaryColors);
  yield takeLatest(constants.RESET_SECONDARY_COLORS, invokeResetSecondaryColors);
  yield takeLatest(constants.FETCH_WRIKE_FOLDER_MEETINGS, invokeFetchWrikeFolderMeetings);
}
